import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  TH,
  TD,
  TableContainer,
  TableRow,
  TableCell,
  TableHeaderCell,
  StyledTableWrapper,
} from "./styles";
import CheckBox from "../customInputs/CheckBox";
import Tooltip from "../Tooltip";
import CustomField from "../CustomField";
import ApprovedButton from "../ApprovedButton";
import ImageVisor from "../ImageVisor";
import { useStore } from "../../../stores/useStore";
import { useModal } from "../../../hooks/useModal";
import Modal from "../Modal";
import FullScreenModal from "../../FullScreenModal";
import useImageProduct from "../../../hooks/useImageProduct";
import { useMultipleEditionStore } from "../../../stores/useMultipleEditionStore";
import { useAutoPrefill } from '../../../hooks/useAutoPrefill'; 

const TableLarge = React.forwardRef((props, ref) => {
  const {
    initialData = [],
    sectionsData,
    headerBaseData,
    headerSectionData,
    withCheckbox,
    selectedSection,
    onSave,
    rejectMessage,
    disabledAttributes = [],
  } = props;
  const [rowsChecked, setRowsChecked] = useState([]);
  const [isImageVisorOpen, setImageVisorOpen] = useState(false);
  const [editedFields, setEditedFields] = useState([]);
  const { modalData, openModal, closeModal, handleCancelClick } = useModal();
  const [isFullScreenModalOpen, setFullScreenModalOpen] = useState(false);
  const [imageDataModal, setSrcImageModal] = useState({
    src: "",
    valueName: "",
  });
  let imageSrc = useImageProduct(imageDataModal.src, 2000, 2000,true);
  const tableSectionRef = useRef(null)
  const { applyInitialRules } = useAutoPrefill();
  const user = JSON.parse(sessionStorage.getItem('user'));

  const toggleFullScreenModal = (name, value) => {
    setSrcImageModal({ src: value, valueName: name });
    setFullScreenModalOpen((prev) => {
      const newState = !prev;
      return newState;
    });
  };

  // const invisibleInputs = [
  //   { inputId: 44024, type: "customField" }
  // ];

  const data = initialData.map((item) => ({
    ...item,
  }));

  const { setCurrentData, store, setArticleID } = useStore();
  const { multipleEditionData, setMultipleEditionData, rules, fetchRules } =
    useMultipleEditionStore();

  const orderedColumns = React.useMemo(() => {
      if (!sectionsData || sectionsData.length === 0) return [];

      const globalOrderMap = {};

      sectionsData.forEach(section => {
        section.dataAttributes.forEach(attr => {
          if (globalOrderMap[attr.id_attribute] === undefined) {
            globalOrderMap[attr.id_attribute] = attr.finalOrderIndex || 0;
          }
        });
      });

      return [...headerSectionData].sort((a, b) => {
        const orderA = globalOrderMap[a.id_attribute] ?? 999;
        const orderB = globalOrderMap[b.id_attribute] ?? 999;

        return orderA - orderB;
      });
    }, [sectionsData, headerSectionData]);

  useEffect(() => {
    fetchRules();
  }, [fetchRules]);

  useEffect(() => {
    if (sectionsData && sectionsData.length > 0) {
      setMultipleEditionData(transformDataForStore(sectionsData));
    }
  }, [sectionsData]);

  useEffect(() => {
    if (sectionsData && sectionsData.length > 0) {
      setCurrentData(sectionsData[0].dataAttributes);
      setArticleID(sectionsData[0].articleId);
      setMultipleEditionData(transformDataForStore(sectionsData));
    }
  }, [sectionsData]);

  useEffect(() => {
    if (rules.length > 0 && sectionsData.length > 0) {
      console.log("Prefill: Ejecutando reglas iniciales...");

      sectionsData.forEach((section) => {
        const articleStore = transformDataForStore([section]);
        applyInitialRules(section.articleId, articleStore[0].articleData);
      });
    }
  }, [rules, sectionsData, applyInitialRules]);

  const transformDataForStore = (incomingData) => {

    const data = incomingData.map((product) => ({
      articleId: product.articleId,
      articleData: product.dataAttributes.map((attribute) => ({
        id_attribute: attribute.id_attribute,
        value: attribute.src ?? attribute.value,
        isApproved: attribute.isApproved,
        comment: attribute.comment,
        option_list: attribute.option_list,
        src: attribute.src,
        prefill: attribute.prefill,
        onboarding_visibility: attribute?.onboarding_visibility
      })),
    }));
    return data;
  };

  function handlerSelectAll(evt) {
    if (evt.target.checked) {
      setRowsChecked(data.map(({ articleId }) => articleId));
    } else {
      setRowsChecked([]);
    }
  }

  function handlerSelect(evt, id) {
    if (evt.target.checked) {
      setRowsChecked((prev) => (prev.includes(id) ? prev : [...prev, id]));
    } else {
      setRowsChecked((prev) => prev.filter((f) => f !== id));
    }
  }

  const handleFieldChange = (
    articleId,
    fieldId,
    newValue,
    isApproved,
    comment,
    isAproval
  ) => {
    if (articleId !== undefined && fieldId !== undefined) {
      setEditedFields((prev) => {
        const updatedFields = [...prev];
        let article = updatedFields.find(
          (item) => item.articleId === articleId
        );

        if (!article) {
          // Si el artículo no existe en el estado, se agrega
          article = { articleId: articleId, fields: {} };
          updatedFields.push(article);
        }

        const existingField = article.fields[fieldId] || {};

        article.fields[fieldId] = {
          value: newValue !== undefined ? newValue : existingField.value,
          isApproved:
            isApproved !== undefined ? isApproved : existingField.isApproved,
          comment: comment !== undefined ? comment : existingField.comment,
        };

        return updatedFields;
      });
    } else {
      console.error("articleId o fieldId es undefined", articleId, fieldId);
    }
  };

  const renderCustomField = (field, typeAccessor, articleId) => {
    const {
      type,
      id_attribute,
      required,
      value,
      comment,
      name_attribute,
      min_chars,
      max_chars,
      isApproved,
      description,
      option_list,
      src,
    } = field;

    const uniqueFieldId = `${articleId}-${id_attribute}`;
    const handleReject = (newIsApproved, newComment) => {
      handleFieldChange(
        articleId,
        id_attribute,
        value,
        newIsApproved,
        newComment
      );
    };

    const editedFieldEntry = editedFields.find(
      (item) => item.articleId === articleId
    );
    const fieldValue = editedFieldEntry?.fields?.[id_attribute]?.value ?? value;

    return (
      <>
        <div className="container-attribute">
          <ApprovedButton
            isApproved={isApproved}
            comment={comment}
            onReject={handleReject}
            id_attribute={id_attribute}
            openModal={openModal}
            closeModal={closeModal}
            articleId={articleId}
            company_id={user?.id_company ?? 0}
            selectedSection={selectedSection}
          />
          {typeAccessor === "imageVisor" ? (
            <ImageVisor
              value={src}
              name={value}
              onToggle={() => setImageVisorOpen((prev) => !prev)}
              toggleFullScreenModal={toggleFullScreenModal}
              articleId={articleId}
              id_attribute={id_attribute}
              // onChange={() => handleFieldChange(articleId, id_attribute, src)}
            />
          ) : (
            <CustomField
              id={uniqueFieldId}
              type={type}
              value={fieldValue}
              required={required}
              max_char={max_chars}
              option_list={option_list}
              typeAccessor={typeAccessor}
              onChange={(newValue) =>
                handleFieldChange(articleId, id_attribute, newValue)
              }
              id_attribute={id_attribute}
              articleId={articleId}
              disabled={disabledAttributes.includes(id_attribute)}
            />
          )}
        </div>
      </>
    );
  };

  const renderRowData = (row, column) => {
    if (
      column.accessor === "customField" ||
      column.accessor === "textArea" ||
      column.accessor === "imageVisor"
    ) {
      const typeAccessor = column.accessor;
      const section = sectionsData.find(
        (section) => section.articleId === row.articleId
      );
      const customFields = section ? section.dataAttributes : [];
      const field = customFields.find(
        (field) => field.id_attribute === column.id_attribute
      );

      if (field) {
        const fieldValue =
          editedFields[row.articleId]?.[field.id_attribute] || field.value;
        return (
          <div key={`${row.articleId}-${field.id_attribute}`}>
            {renderCustomField(
              {
                ...field,
                value: fieldValue,
              },
              typeAccessor,
              row.articleId
            )}
          </div>
        );
      }
      return "-";
    } else {
      return row[column.accessor] || "-";
    }
  };

  useEffect(() => {
    if (ref) {
      ref.current = tableSectionRef.current;
    }
  }, [ref]);

  return (
    <Container
      withCheckbox={withCheckbox}
      isImageVisorOpen={isImageVisorOpen}
      ref={ref}
    >
      <TableContainer>
        {/* Encabezado de la tabla */}
        <TableRow>
          {headerBaseData
            .filter(
              (column) =>
                column.Header !== "Ver." && column.Header !== "Cadenas",
            )
            .map((column, index) => (
              <TableHeaderCell key={`header-${index}`}>
                {column.Header || column.name_attribute}
              </TableHeaderCell>
            ))}
        </TableRow>
        {/* Filas de datos */}
        {data.map((row, rowIndex) => (
          <TableRow key={`row-${rowIndex}`}>
            {headerBaseData
              .filter(
                (column) =>
                  column.Header !== "Ver." && column.Header !== "Cadenas",
              )
              .map((column, colIndex) => (
                <TableCell key={`cell-${rowIndex}-${colIndex}`}>
                  {renderRowData(row, column)}
                </TableCell>
              ))}
          </TableRow>
        ))}
      </TableContainer>
      <StyledTableWrapper ref={tableSectionRef}>
        <table className="custom-table">
          <thead>
            <tr>
              {orderedColumns.map((column, i) => {
                const attributeMeta = sectionsData
                  .flatMap(s => s.dataAttributes)
                  .find(attr => attr.id_attribute === column.id_attribute);

                return (
                  <TH
                    key={`section-${i}`}
                    // className={`${
                    //   invisibleInputs.some(input => input?.inputId === column?.id_attribute && input?.type === column?.accessor) ? 'invisible' : ''
                    // }`}
                    withCheckbox={withCheckbox}
                    {...column}
                    fixed={false}
                  >
                    <Tooltip
                      title={attributeMeta?.description || "Sin descripción"}
                      position="top"
                      variant="white"
                    >
                      <span>
                        {column.Header}
                        {attributeMeta?.required ? " *" : ""}
                      </span>
                    </Tooltip>
                  </TH>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.articleId}>
                {orderedColumns.map((column, i) => (
                  <TD
                    key={`section-${column.accessor}-${i}`}
                    withCheckbox={withCheckbox}
                    // className={`${
                    //   invisibleInputs.some(input => input?.inputId === column?.id_attribute && input?.type === column?.accessor) ? 'invisible' : ''
                    // }`}
                    {...column}
                  >
                    {renderRowData(row, column)}
                  </TD>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </StyledTableWrapper>
      <Modal {...modalData} onClose={handleCancelClick} />
      {isFullScreenModalOpen && (
        <FullScreenModal
          name={imageDataModal.value}
          toggleFullScreenModal={toggleFullScreenModal}
          imageSrc={imageSrc}
        />
      )}
    </Container>
  );
});

export default TableLarge;
